// extracted by mini-css-extract-plugin
module.exports = {"accordionDeal":"e_xp","buttonHolder":"e_yp","button":"e_zp"};